export var config = {
  apiKey: "AIzaSyCDj8OTRlerNIEO1f2e-HF6-YfS4lAsTxc",
     authDomain: "ionicmap-8b1d0.firebaseapp.com",
     databaseURL: "https://ionicmap-8b1d0.firebaseio.com",
     projectId: "ionicmap-8b1d0",
     storageBucket: "ionicmap-8b1d0.appspot.com",
     messagingSenderId: "943024581452"
  };



// WEBPACK FOOTER //
// ./src/app/credentials.ts